import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "@/i18n";

const API = `/api`;

export const AiProcessingSection = () => (
  <div className="fiche-content" data-testid="legal-ai-section">
    <div className="gold-hairline my-10" />
    <h2>Traitement par intelligence artificielle</h2>
    <p>
      Notre site propose un assistant de recherche qui répond à vos questions exclusivement à
      partir des publications du cabinet. Pour générer sa réponse, votre question est transmise à
      un prestataire technique (modèle de langage). Vos questions ne sont ni conservées, ni
      utilisées à d'autres fins, ni associées à votre identité.
    </p>
    <p>
      <strong>
        Ce service automatisé n'est pas couvert par le secret professionnel.
      </strong>{" "}
      Nous vous invitons à n'y saisir aucune information confidentielle ou nominative. Pour toute
      question confidentielle, contactez directement le cabinet : vos échanges avec un avocat sont,
      eux, couverts par le secret professionnel.
    </p>
    <p>
      Les réponses de l'assistant constituent une information générale et ne sauraient valoir
      conseil juridique. Le cabinet ne saurait être tenu responsable d'une décision prise sur la
      seule base de ces réponses automatisées.
    </p>
  </div>
);

export default function Legal({ slug, title, extra = null }) {
  const [content, setContent] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    setContent(null);
    fetch(`${API}/knowledge/articles/${slug}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => setContent(d ? d.content_html : ""))
      .catch(() => setContent(""));
    document.title = `${title} — e².law`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", `${title} du cabinet e².law, avocats d'affaires à Bruxelles.`);
    return () => {
      document.title = "e².law — Cabinet d'avocats d'affaires · Bruxelles";
    };
  }, [slug, title]);

  return (
    <div className="pt-40 pb-24 sm:pb-32 min-h-screen" data-testid={`legal-${slug}`}>
      <div className="max-w-3xl mx-auto px-6 sm:px-12">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#A0A5B1] hover:text-gold transition-colors duration-300"
        >
          <ArrowLeft className="w-4 h-4" /> {t("legal.back")}
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="label-accent mt-10 block">e².law — Bruxelles</span>
          <h1 className="mt-5 font-serif font-light tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-tight" data-testid="legal-title">
            {title}
          </h1>
          <div className="mt-8 gold-hairline" />

          {content === null ? (
            <p className="mt-10 text-[#9BA1B0] font-mono text-sm">{t("legal.loading")}</p>
          ) : (
            <>
              <div className="fiche-content mt-10" data-testid="legal-content" dangerouslySetInnerHTML={{ __html: content }} />
              {extra}
            </>
          )}
        </motion.div>
      </div>
    </div>
  );
}
